class EnvironmentCharts {
  constructor(selector = '.js-environment-data-inview') {
    this.cards = Array.from(document.querySelectorAll(selector));

    if (!this.cards.length) {
      return;
    }

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.hasChart = typeof Chart !== 'undefined';

    if (this.reducedMotion || !('IntersectionObserver' in window)) {
      this.cards.forEach((card) => this.reveal(card));
    } else {
      this.observe();
    }
  }

  parseNumbers(value) {
    return String(value || '')
      .split(',')
      .map((item) => Number(item.trim()))
      .filter((item) => !Number.isNaN(item));
  }

  observe() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          return;
        }

        this.reveal(entry.target);
        this.observer.unobserve(entry.target);
      });
    }, {
      root: null,
      // Android 実機でアドレスバー伸縮時にも発火するよう、中心帯を広めに取る
      rootMargin: '-20% 0px -20% 0px',
      threshold: 0,
    });

    this.cards.forEach((card) => this.observer.observe(card));

    // IntersectionObserver が発火しない端末向けのフォールバック
    window.setTimeout(() => {
      this.cards.forEach((card) => {
        if (!card.classList.contains('is-inview')) {
          this.reveal(card);
        }
      });
    }, 2500);
  }

  reveal(card) {
    if (card.classList.contains('is-inview')) {
      return;
    }

    card.classList.add('is-inview');

    if (!this.hasChart) {
      return;
    }

    card.querySelectorAll('.js-environment-chart').forEach((canvas) => {
      this.createChart(canvas);
    });
  }

  createChart(canvas) {
    if (canvas.dataset.chartInited === '1') {
      return;
    }

    const type = canvas.dataset.chart;
    const prepared = this.preparePie(type, canvas);

    if (!prepared) {
      return;
    }

    canvas.dataset.chartInited = '1';

    const { colors, data } = prepared;
    const startData = this.reducedMotion ? data : data.map(() => 0);
    const chart = new Chart(canvas.getContext('2d'), this.pieConfig(colors, startData, false));

    if (this.reducedMotion) {
      return;
    }

    const play = () => {
      if (!chart.canvas || !chart.canvas.isConnected) {
        return;
      }

      if (!chart.width) {
        chart.resize();
      }

      if (!chart.width) {
        requestAnimationFrame(play);
        return;
      }

      chart.options.animation = this.pieAnimation();
      chart.data.datasets[0].data = data;
      chart.update();
    };

    requestAnimationFrame(() => {
      requestAnimationFrame(play);
    });
  }

  pieAnimation() {
    return {
      animateRotate: true,
      animateScale: false,
      onComplete(animation) {
        const chart = animation.chart;

        if (chart && chart.options) {
          chart.options.animation = false;
        }
      },
    };
  }

  pieOptions(animated) {
    return {
      responsive: true,
      maintainAspectRatio: false,
      animation: animated ? this.pieAnimation() : false,
      events: [],
      layout: {
        autoPadding: false,
        padding: 0,
      },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
        },
      },
      rotation: 0,
      radius: '100%',
      elements: {
        arc: {
          borderWidth: 0,
        },
      },
    };
  }

  preparePie(type, canvas) {
    if (type === 'gender') {
      return {
        colors: ['#25A7DE', '#20509A'],
        data: this.parseNumbers(canvas.dataset.chartValues),
      };
    }

    if (type === 'age') {
      return {
        colors: ['#20509A', '#2166AB', '#2491CD', '#25A7DE', '#7DD3F0'],
        data: this.parseNumbers(canvas.dataset.chartValues),
      };
    }

    return null;
  }

  pieConfig(colors, data, animated) {
    return {
      type: 'pie',
      data: {
        datasets: [{
          data: data,
          backgroundColor: colors,
          borderWidth: 0,
          hoverOffset: 0,
          spacing: 0,
          offset: 0,
        }],
      },
      options: this.pieOptions(animated),
    };
  }
}
